import React from "react"
import { ThemeProvider } from "styled-components"
import { Helmet } from "react-helmet"
import variables from "src/styles/variables"
import StylesReset from "src/styles/reset"
import StylesBase from "src/styles/base"
import Header from "src/components/Header/Header"
import Footer from "src/components/Footer/Footer"

class BaseLayout extends React.Component {
  render() {
    const pathname = this.props.location.pathname
    let headerVariant = [
      "/",
      "/about/how-we-work",
      "/about/how-we-work/",
      "/about/mission-and-values",
      "/about/mission-and-values/",
      "/donate",
      "/donate/",
      "/contact",
      "/contact/",
      "/get-involved/jobs",
      "/get-involved/jobs/",
      "/full-stack-developer",
      "/full-stack-developer/",
      "/global-fundraising-specialist",
      "/global-fundraising-specialist/",
      "/resources",
      "/resources/",
      "/subscribed",
      "/subscribed/",
      "/thank-you",
      "/thank-you/",
    ].includes(pathname)
      ? "light"
      : "dark"

    return (
      <ThemeProvider theme={variables}>
        <React.Fragment>
          <Helmet defer={false}>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            />
          </Helmet>
          <StylesReset />
          <StylesBase />
          <Header variant={headerVariant} pathname={pathname} />
          <main>{this.props.children}</main>
          <Footer />
        </React.Fragment>
      </ThemeProvider>
    )
  }
}

export default BaseLayout
